module.exports = __webpack_public_path__ + "static/media/gujarat.9c8e03c4.jpg";